
import {transactionsType} from "../../AppConstants";
import { find } from 'lodash';


export const getTransactionsLabel = (type) => {

    let element = find(transactionsType, x => x.value === type);
    if (element) {
        return element.label;
    }
    return type
}